/** Derive default org name from email, e.g. ``anant@damle.xyz`` → ``anant_damle_xyz organization``. */
export function organizationNameFromEmail(email: string): string {
  const sanitized = email
    .trim()
    .toLowerCase()
    .replace(/@/g, '_')
    .replace(/\./g, '_')
    .replace(/[^a-z0-9_+-]/g, '_');
  return `${sanitized} organization`;
}
